import React, { useMemo } from 'react';
import { Bar, BarChart, Legend, XAxis, YAxis } from 'recharts';
import { CHART_CONFIG } from './constants';
import * as styles from './styles.css';
import type { IRechartProps } from './types';
import { buildChartData, customizedGroupTick, customLegend, DefaultBarShape } from './utils';
import { clsx } from 'clsx';

export type { IRechartProps } from './types';

export const Rechart: React.FC<IRechartProps> = ({ limitValue, device }) => {
  const chartData = useMemo(() => buildChartData(limitValue), [limitValue]);

  return (
    <div className={clsx(styles['recharts'], styles[device])}>
      <BarChart style={{ width: '100%', height: CHART_CONFIG.height }} data={chartData}>
        <XAxis dataKey="name" tick={customizedGroupTick} tickLine={false} stroke="#C9D1E5" color="#C9D1E5" />
        <YAxis hide domain={CHART_CONFIG.yDomain} />
        <Legend content={customLegend} verticalAlign="top" align="center" wrapperStyle={{ top: '10px', bottom: '' }} />
        <Bar
          dataKey="default"
          name="Остальные"
          stackId="a"
          fill="#8AABFE"
          barSize={CHART_CONFIG.barSize}
          shape={<DefaultBarShape />}
        />
        <Bar
          dataKey="increase"
          name="От продвижения"
          stackId="a"
          fill="#FDC889"
          radius={[5, 5, 0, 0]}
          style={{ transform: 'translate(0,-2px)' }}
          barSize={CHART_CONFIG.barSize}
        />
      </BarChart>
    </div>
  );
};
